import { Injectable, signal } from '@angular/core';

export interface BannerMessage {
  severity: 'success' | 'info' | 'warn' | 'error';
  summary: string;
  detail: string;
  type: BannerMessageType
}

export type BannerMessageType = 'assemblyInherited' | 'plan' | 'office' | 'category' | 'template' | 'tax' | 'other' | 'assembly';

@Injectable({
  providedIn: 'root'
})
export class BannerMessagesService {

  messages=signal< BannerMessage[] | undefined>(undefined);

  constructor() { }

  addMessages(messages: BannerMessage[]) {
    this.messages.set([...(this.messages() || []), ...messages]);
  }

  removeMessage(message: BannerMessage) {
    this.messages.update(messages => messages?.filter(m => m !== message));
  }

  clearType(type: BannerMessageType) {
    this.messages.update(messages => messages?.filter(m => m.type !== type));
  }

  replaceMessageType(messages: BannerMessage[], type:BannerMessageType) {
    this.messages.update(messages => messages?.filter(m => m.type !== type));
    this.addMessages(messages);
  }

  clearMessages() {
    this.messages.set(undefined);
  }
  
  
}
